import React from "react";
import Container from "@material-ui/core/Container";
import { withStyles, WithStyles } from "@material-ui/core/styles";
import { getSubscription } from "ls/subscription";
import lsClient from "ls/client";
import { Instrument } from "apis/models/commons/instrument";
import { Column } from "models/common";
import SnackbarContent from "taskpane/components/Common/Snackbar";
import Alert from "taskpane/components/Common/Alert";
import Header from "taskpane/components/Header";
import { alertAction, MarketTypes, snackbarTypes, typeAlert, LsSubscriptionTableFields } from "constants/globals";
import { BLACK, WHITE } from "constants/colors";
import { arrayValidation, getErrorApis, getErrorExcel, isEmpty } from "utils/functions";
import { headerColumnArray } from "./SelectPredefinedTable";
import Market from "./Market";
import { NewTable } from "./SelectPredefinedTable/ExporterNewTable";
import { styles } from "./styles";
import {
  AppProps,
  AppState,
  initDataSnackbar,
  initDataAlert,
  AddTableParams,
  RealTimeParams,
  UpdateRowTableParams,
  Card,
  RowMoreInfo,
} from "./types";
import {
  calculateRange,
  convertValue,
  fetchTableData,
  getCardByAddress,
  getColor,
  getFormatInstrumentForLS,
  getFormatInstrumentWithPositionFieldsForLS,
  getNextColumn,
  convertValueToPercentage,
} from "./helpers";
import { Button } from "@material-ui/core";
import SideTab from "./SideTab/SideTab";
import { dataTableColumns, formats, historyColumList } from "./constants";
import {
  getHistoricalData,
  getHistoricalFundData,
  getHistoricalIndicatorsData,
  getHistoricalReferralMateriasData,
  getHistoricalReferralTessaData,
} from "apis/download";

let client;
let self;
var formatInstrumentForLS = [];
var formatInstrumentWithPositionFieldsForLS = [];
var finalColumnArr = [];
var rememberCredentials = true;
var isSortedColoumns = true;

class ExcelAddIn extends React.Component<AppProps & WithStyles<typeof styles>, AppState> {
  constructor(props) {
    super(props);
    this.state = {
      copyBtn: false,
      cardPaste: false,
      cardTableEnabled: false,
      errorRender: false,
      responsestate: "error",
      dataTable: null,
      TableNameTitle: null,
      subscription: null,
      dataSnackbar: initDataSnackbar,
      dataitem: ["Instrumento"],
      childData: null,
      dataAlert: initDataAlert,
      copyCard: {
        address: "",
        worksheetId: "",
        isCopy: false,
      },
      currentCard: {
        address: "",
        instruments: [],
        worksheetId: "",
        tableName: "",
        columnList: [],
      },
      activeCards: [],
      updateMarketTable: false,
      dataRealTimeParams: [],
      addressItem: "",
      activeTab: "Insertar tabla",
      downloadHistorySuccess: true,
    };
  }

  ranges = [];

  componentDidMount() {
    client = lsClient();
    self = this;

    if (Office.context.requirements.isSetSupported("ExcelApi", "1.7")) {
      Excel.run(function (context) {
        var worksheet = context.workbook.worksheets;
        worksheet.onSelectionChanged.add(handleSelectionChange);
        worksheet.onRowSorted.add(handleRowSorted);
        return context.sync();
      });
    }

    if (client) {
      const dataRealTimeParams: RealTimeParams[] = Office.context.document.settings.get("dataRealTimeParams");
      let tempInstrumentArr = [];

      if (dataRealTimeParams && arrayValidation(dataRealTimeParams)) {
        this.setState({ dataRealTimeParams });
        setTimeout(async () => {
          await dataRealTimeParams.forEach((dataRealTimeParam) => {
            var respInstrumentData = fetchTableData(dataRealTimeParam.activeCard.instruments, "");

            tempInstrumentArr.push(respInstrumentData);
          });
          for (let index = 0; index < tempInstrumentArr.length; index++) {
            const data = await tempInstrumentArr[index];

            var tempUpdateObj = {
              rows: data,
              address: dataRealTimeParams[index].activeCard.address,
              marketId: dataRealTimeParams[index].activeCard.marketId,
              worksheetId: dataRealTimeParams[index].worksheetId,
              columnList: dataRealTimeParams[index].activeCard.columnList,
              tableWithHeader: dataRealTimeParams[index].activeCard.tableWithHeader,
            };

            await this.updateTable(tempUpdateObj);
            await this.getRealTime(dataRealTimeParams[index]);
          }
        }, 50);
      }
    }
  }

  componentWillUnmount() {
    let isMounted = true;
    const { activeCards } = this.state;
    if (isMounted) {
      if (client && activeCards && activeCards.length > 0) {
        activeCards.forEach(async (activeCard) => {
          await client.unsubscribe(activeCard.subscription);
          activeCard.subscription.removeListener(activeCard.address);
        });
        isMounted = false;
      }
    }
  }

  updateTable = async ({ rows, address, marketId, worksheetId, columnList, tableWithHeader }) => {
    const that = this;
    let rowNumber = 0;
    let startingColumnValue = "";
    let finalColumnValue = "";

    try {
      await Excel.run(async (context) => {
        var activeCell = context.workbook.getSelectedRange();
        activeCell.load(["address", "values"]);
        await context.sync();
        var value = address ? address : activeCell.address;
        if (columnList.length > 0) {
          const { initialRow, finalRow, initialColumn, finalColumn } = calculateRange(String(value), columnList.length);
          startingColumnValue = initialColumn;
          finalColumnValue = finalColumn;

          var worksheet = context.workbook.worksheets.getItem(worksheetId);

          rows = rows.filter((item) => {
            if (item.instrumento !== "" && item.hasOwnProperty("instrumento")) {
              return item;
            }
          });

          // table headers
          let rowHeader;

          if (tableWithHeader) {
            rowHeader = Number(initialRow) + 1;
          } else {
            rowHeader = Number(initialRow) - 1;
          }

          // table body
          let currentRow = Number(rowHeader);
          rowNumber = Number(rowHeader);
          let range;
          let currentCellBody;
          let valueCellBody;

          const isNationalBags =
            marketId === MarketTypes.BMV.id ||
            marketId === MarketTypes.BIVA.id ||
            marketId === MarketTypes.BMV_SIC.id ||
            marketId === MarketTypes.BIVA_SIC.id;

          const rowMoreInfo: RowMoreInfo[] = [];
          const isCurrency = marketId === MarketTypes.CURRENCY.id;
          let currencyPosturaPrecioCompraCell = null;
          let currencyPosturaPrecioVentaCell = null;

          // Read the row data
          rows.forEach((row) => {
            currentCellBody = startingColumnValue;
            currentRow++;

            if (isNationalBags) {
              const currentPrice = Number(row["precioActual"] || 0);
              const weeklyNumber = Number(row["rendimientoSemanal"] || 0) / 100;
              const monthlyNumber = Number(row["rendimientoMensual"] || 0) / 100;
              const annualNumber = Number(row["rendimientoAnual"] || 0) / 100;
              const annualYield = Number(row["rendimientoAlAnio"] || 0) / 100;

              const semanalPrice = currentPrice / (weeklyNumber + 1);
              const monthlyPrice = currentPrice / (monthlyNumber + 1);
              const annualPrice = currentPrice / (annualNumber + 1);
              const enAnoPrice = currentPrice / (annualYield + 1);

              rowMoreInfo.push({
                displaySymbol: row.descripcion || "",
                semanalPrice,
                monthlyPrice,
                annualPrice,
                enAnoPrice,
              });
            }
            columnList.forEach(async (header) => {
              range = worksheet.getRange(`${currentCellBody}${currentRow}`);

              valueCellBody = row[header.apiField];

              if (Office.context.requirements.isSetSupported("ExcelApi", "1.2")) {
                range.format.horizontalAlignment = header.align;
              }

              if (isCurrency) {
                if (!currencyPosturaPrecioCompraCell && header.apiField === "posturaPrecioCompra") {
                  currencyPosturaPrecioCompraCell = currentCellBody;
                }
                if (!currencyPosturaPrecioVentaCell && header.apiField === "posturaPrecioVenta") {
                  currencyPosturaPrecioVentaCell = currentCellBody;
                }
              }
              if (
                marketId === MarketTypes.REFERENCE_RATES.id &&
                (header.apiField === "valorActual" || header.apiField === "valorAnterior")
              ) {
                valueCellBody = convertValueToPercentage(valueCellBody ? String(valueCellBody) : "");
              }
              currentCellBody = getNextColumn(currentCellBody);
              if (isCurrency && header.name === "spread") {
                range.numberFormat = "###########0.00###########";
                range.values = `=${currencyPosturaPrecioVentaCell}${currentRow}-${currencyPosturaPrecioCompraCell}${currentRow}`;
              } else {
                if (header.format == formats.DATE) {
                  range.numberFormat = "dd-MM-yy";
                  range.values = convertValue(valueCellBody, header, false);
                } else {
                  range.values = convertValue(valueCellBody, header, false);
                }
              }
            });
          });

          if (Office.context.requirements.isSetSupported("ExcelApi", "1.2")) {
            worksheet.getUsedRange().format.autofitColumns();
          }
          return context.sync().then(() => {
            this.props.setShowSpinner(false);
          });
        } else {
          this.props.setShowSpinner(false);
          <Alert
            open={initDataAlert.showAlert}
            type={initDataAlert.type}
            title={initDataAlert.title}
            message={initDataAlert.message}
            handleClose={this.handleCloseAlert}
            emitter={this.handleEmitterAlert}
            sizeOverride={70}
          />;
        }
        await context.sync();
      });
    } catch (error) {
      console.error("err RealTime: ", error);
      this.props.setShowSpinner(false);
    }
  };

  showSnackbar = (severity: string, message: string, autoHideDuration: number) => {
    this.setState({
      dataSnackbar: {
        showSnackbar: true,
        severity,
        message,
        autoHideDuration: Number(autoHideDuration),
      },
    });
  };

  handleCloseSnackbar = () => {
    this.setState({
      dataSnackbar: {
        ...initDataSnackbar,
      },
    });
  };

  handleCloseAlert = () => {
    this.setState({
      dataAlert: {
        ...initDataAlert,
      },
    });
  };
  handlecloseerror = (error) => {
    this.setState({ errorRender: error });
  };

  saveSettingDataRealTime = (dataRealTimeParams: RealTimeParams[]) => {
    try {
      Office.context.document.settings.set("dataRealTimeParams", dataRealTimeParams);
      Office.context.document.settings.saveAsync(function (asyncResult) {
        if (asyncResult.status == Office.AsyncResultStatus.Failed) {
          console.log("Settings save failed. Error: " + asyncResult.error.message);
        } else {
          console.log("Settings saved.");
        }
      });
    } catch (error) {
      console.log("error", error);
    }
  };

  cleanCard = async (address, worksheetId) => {
    try {
      await Excel.run((context) => {
        var worksheet = context.workbook.worksheets.getItem(worksheetId);
        let range = worksheet.getRange(address);
        range.clear();

        return context.sync();
      });
    } catch (error) {
      console.error(error);
      this.props.setShowSpinner(false);
      this.setState({ errorRender: !this.state.errorRender });
      this.showSnackbar(snackbarTypes.ERROR, getErrorExcel(error), 5000);
    }
  };

  startCleaningProcessCard = async () => {
    const { currentCard, activeCards } = this.state;

    const card = getCardByAddress(activeCards, currentCard.address, currentCard.worksheetId);

    let addressOrigin = "";
    if (card) {
      const { initialColumn, initialRow, finalColumn, rowNumber } = card;
      const finalRow = initialRow + rowNumber - 1;
      const address = `${initialColumn}${initialRow}:${finalColumn}${finalRow}`;
      await client.unsubscribe(card.subscription);
      await this.cleanCard(address, card.worksheetId);
      let tempActiveCards = [...activeCards];
      tempActiveCards = tempActiveCards.filter(
        (activeCard) => activeCard.address !== card.address || activeCard.worksheetId !== card.worksheetId
      );

      this.setState({
        activeCards: tempActiveCards,
      });

      addressOrigin = card.address;
    }
    return addressOrigin;
  };
  handleCallback = (childData: any) => {
    this.setState({ dataitem: childData });
  };
  getColumnItems = () => {
    let headersColumn = [];
    let record;
    const columnList = [];
    let selectedHeadersColumn = [];

    if (finalColumnArr.length > 0) {
      headersColumn = finalColumnArr;
      selectedHeadersColumn = finalColumnArr;
    } else {
      headersColumn = headerColumnArray();
      for (let entry of this.state.dataitem) {
        record = headersColumn.find((element) => {
          return element.description === entry;
        });
        selectedHeadersColumn.push(record);
      }
    }

    if (isSortedColoumns) {
      selectedHeadersColumn = selectedHeadersColumn.sort((a, b) => (a.id > b.id ? 1 : -1));
    }
    isSortedColoumns = true;

    for (let entry of selectedHeadersColumn) {
      record = dataTableColumns.find((element) => {
        return element.apiField === entry.name;
      });

      let column: Column = {} as Column;
      if (record != null) {
        column = record;
        column.apiField = entry.name;
        column.name = entry.description;
        column.label = entry.description;
      } else {
        column.apiField = entry.name;
        column.name = entry.description;
        column.format = "string";
      }
      columnList.push(column);
    }
    return columnList;
  };

  setColumArr = (data, isSorted) => {
    finalColumnArr = data;
    isSortedColoumns = isSorted;
  };

  handleRememberCredentials = (data) => {
    rememberCredentials = data;
  };

  onClickMarket = (instruments: Instrument[], tableName) => {
    this.setState({ TableNameTitle: tableName });
    this.setState({ updateMarketTable: true });
    this.props.setShowSpinner(true);
    const columnList = this.getColumnItems();
    this.validateAddTable(instruments, tableName, columnList);
  };

  cutAddTable = async () => {
    const { activeCards } = this.state;
    Excel.run(async (context) => {
      var worksheet = context.workbook.worksheets.getActiveWorksheet();

      var activeCell = context.workbook.getSelectedRange();
      activeCell.load(["address", "values", "worksheet/id"]);
      return await context.sync().then(async () => {
        const address = activeCell.address;
        const worksheetId = activeCell.worksheet.id;

        const card = getCardByAddress(activeCards, address, worksheetId);
        if (card) {
          this.setState({
            cardPaste: true,

            copyCard: {
              address,
              worksheetId,
              isCopy: false,
            },
          });
        } else {
          this.setState({
            copyCard: {
              address: "",
              worksheetId: "",
              isCopy: false,
            },
          });
        }
        return context.sync();
      });
    });
  };
  copyAddTable = () => {
    const { activeCards } = this.state;
    this.setState({ copyBtn: true });
    Excel.run(async (context) => {
      var activeCell = context.workbook.getActiveCell();
      activeCell.load(["address", "values", "worksheet/id"]);
      return await context.sync().then(async () => {
        const address = activeCell.address;
        const worksheetId = activeCell.worksheet.id;

        const card = getCardByAddress(activeCards, address, worksheetId);
        if (card) {
          this.setState({
            cardPaste: true,

            copyCard: {
              address,
              worksheetId,
              isCopy: true,
            },
          });
        } else {
          this.setState({
            copyCard: {
              address: "",
              worksheetId: "",
              isCopy: false,
            },
          });
          return card;
        }
        return context.sync();
      });
    });
  };
  pasteAddTable = async () => {
    const { copyCard, activeCards } = this.state;
    if (copyCard.address) {
      const card = getCardByAddress(activeCards, copyCard.address, copyCard.worksheetId);

      if (card) {
        const { initialColumn, initialRow, finalColumn, rowNumber } = card;
        const finalRow = initialRow + rowNumber - 1;
        const address = `${initialColumn}${initialRow}:${finalColumn}${finalRow}`;

        this.validateAddTable(card.instruments, card.tableName, card.columnList);

        if (copyCard.isCopy === false) {
          await client.unsubscribe(card.subscription);
          await this.cleanCard(address, copyCard.worksheetId);
          let tempActiveCards = [...activeCards];
          tempActiveCards = tempActiveCards.filter(
            (activeCard) => activeCard.address !== card.address || activeCard.worksheetId !== card.worksheetId
          );

          this.setState({
            activeCards: tempActiveCards,
          });

          this.setState({
            cardPaste: false,

            copyCard: {
              address: "",
              worksheetId: "",
              isCopy: false,
            },
          });
        }
      }
    }
  };

  validateAddTable = (instruments: Instrument[], tableName, columnList) => {
    try {
      Excel.run(async (context) => {
        this.props.setShowSpinner(false);
        var activeCell = context.workbook.getSelectedRange();
        activeCell.load(["address", "values", "worksheet/id"]);
        return await context
          .sync()
          .then(() => {
            const cellValue = activeCell.values[0][0];
            const address = activeCell.address;
            const worksheetId = activeCell.worksheet.id;
            if (!isEmpty(cellValue)) {
              this.setState({
                currentCard: {
                  address,
                  instruments,
                  worksheetId,
                  tableName,
                  columnList,
                },
                dataAlert: {
                  showAlert: true,
                  type: typeAlert.CONFIRMATION,
                  title: "¿Reemplazar la tarjeta actual?",
                  message: "Estás a punto de reemplazar la tarjeta actual. ¿Seguro que quieres continuar?",
                },
              });
            } else {
              this.precessAddTableToExcel(address, instruments, tableName, worksheetId, columnList);
            }
          })
          .then(context.sync);
      });
    } catch (error) {
      console.error(error);
      this.showSnackbar(snackbarTypes.ERROR, getErrorExcel(error), 5000);
      this.props.setShowSpinner(false);
    }
  };

  handleEmitterAlert = async (resp) => {
    const action = resp && resp.action ? resp.action : "";

    switch (action) {
      case alertAction.CONFIRM:
        this.handleCloseAlert();
        this.props.setShowSpinner(true);
        const { currentCard } = this.state;
        const address = await this.startCleaningProcessCard();
        this.precessAddTableToExcel(
          address,
          currentCard.instruments,
          currentCard.tableName,
          currentCard.worksheetId,
          currentCard.columnList
        );
        break;
      case alertAction.CANCEL:
        this.handleCloseAlert();
        this.setState({ updateMarketTable: false });
        break;
      default:
        this.setState({ updateMarketTable: false });
        console.log("Opción no valida");
        break;
    }
  };

  precessAddTableToExcel = async (address: string, instruments: Instrument[], tableName, worksheetId, columnList) => {
    this.props.setShowSpinner(true);

    try {
      let marketId;
      if (arrayValidation(instruments)) {
        marketId = instruments[0].marketId;
      }

      //API CALL
      let respInstrumentData = await fetchTableData(instruments, "");
      respInstrumentData = respInstrumentData.filter((item) => {
        if (item.instrumento !== "" && item.hasOwnProperty("instrumento")) {
          return item;
        }
      });
      if (instruments.length !== respInstrumentData.length) {
        formatInstrumentForLS = getFormatInstrumentForLS(respInstrumentData);
        formatInstrumentWithPositionFieldsForLS = getFormatInstrumentWithPositionFieldsForLS(respInstrumentData);
      } else {
        formatInstrumentForLS = getFormatInstrumentForLS(instruments);
        formatInstrumentWithPositionFieldsForLS = getFormatInstrumentWithPositionFieldsForLS(instruments);
      }

      this.setState({ updateMarketTable: false });
      this.addTableToExcel({
        formatInstrumentForLS,
        formatInstrumentWithPositionFieldsForLS,
        rows: respInstrumentData,
        tableName: tableName,
        address,
        marketId: Number(marketId),
        worksheetId,
        columnList,
        instruments,
      });
    } catch (error) {
      this.showSnackbar(snackbarTypes.ERROR, getErrorApis(error), 5000);
      this.setState({ updateMarketTable: false });
      this.props.setShowSpinner(false);
    }
  };

  setColorDefaultToCell = () => {
    return new Promise((resolve, reject) => {
      const clearID = setTimeout(() => {
        try {
          Excel.run(async (context) => {
            var worksheet = context.workbook.worksheets.getActiveWorksheet();
            const tempRanges = [...this.ranges];
            if (tempRanges && tempRanges.length > 0) {
              tempRanges.forEach(async (cellRange) => {
                let range = worksheet.getRange(cellRange);
                range.format.font.color = BLACK;
                await context.sync();
                this.ranges = this.ranges.filter((range) => range !== cellRange);
              });
            }
            await context.sync();
          }).then(() => resolve(null));
        } catch (error) {
          console.error("setColorDefaultToCell", error);
          reject(error);
        }
      }, 500);

      clearTimeout(clearID);
    });
  };

  updateRowTable = ({ columnList, data, startingColumnValue, rowNumber, worksheetId }: UpdateRowTableParams) => {
    return new Promise((resolve, reject) => {
      try {
        Excel.run(async (context) => {
          let currentCellBody = startingColumnValue;
          let value;
          let indexRange;
          var worksheet = context.workbook.worksheets.getItem(worksheetId);
          for (let index = 0; index < columnList.length; index++) {
            const header = columnList[index];
            try {
              value = data[header.lsField];
              if (!isEmpty(value) && !isEmpty(String(header.lsField))) {
                let range = worksheet.getRange(`${currentCellBody}${rowNumber}`);
                range.values = [[convertValue(String(value), header, true)]];
                if (header.apiField !== "porcentaje") {
                  indexRange = this.ranges.indexOf(`${currentCellBody}${rowNumber}`);
                  if (indexRange < 0) {
                    this.ranges.push(`${currentCellBody}${rowNumber}`);
                  }
                }
                await context.sync();
              }
            } catch (error) {}
            currentCellBody = getNextColumn(currentCellBody);
          }

          this.setColorDefaultToCell();
          return context.sync().then(async () => {
            resolve(null);
          });
        });
      } catch (error) {
        reject(error);
      }
    });
  };

  getYields = (data: any, rowMoreInfo: RowMoreInfo) => {
    const updateDataObject = {};
    const { semanalPrice, monthlyPrice, annualPrice, enAnoPrice } = rowMoreInfo;
    const currentPrice = parseFloat(data.Sd[2].replace(",", ""));

    if (isNaN(currentPrice) || !semanalPrice || !monthlyPrice || !annualPrice || !enAnoPrice) {
      return {};
    }

    updateDataObject["rendimientoSemanal"] = (currentPrice / semanalPrice - 1) * 100;
    updateDataObject["rendimientoMensual"] = (currentPrice / monthlyPrice - 1) * 100;
    updateDataObject["rendimientoAnual"] = (currentPrice / annualPrice - 1) * 100;
    updateDataObject["rendimientoAlAnio"] = (currentPrice / enAnoPrice - 1) * 100;

    return updateDataObject;
  };
  getRealTime = async ({
    formatInstrumentForLS,
    formatInstrumentWithPositionFieldsForLS,
    rowNumber,
    startingColumnValue,
    finalColumnValue,
    activeCard,
    worksheetId,
  }: RealTimeParams) => {
    let { dataRealTimeParams } = this.state;
    self = this;
    dataRealTimeParams = dataRealTimeParams.filter((dataRealTimeParam) => {
      const dtActiveCard = dataRealTimeParam.activeCard;
      return dtActiveCard.address !== activeCard.address || dataRealTimeParam.worksheetId !== worksheetId;
    });

    dataRealTimeParams = [
      ...dataRealTimeParams,
      {
        formatInstrumentForLS,
        formatInstrumentWithPositionFieldsForLS,
        rowNumber,
        startingColumnValue,
        finalColumnValue,
        activeCard,
        worksheetId,
      },
    ];
    this.setState({ dataRealTimeParams });

    this.saveSettingDataRealTime(dataRealTimeParams);

    try {
      let lsColumns = [];
      activeCard.columnList.forEach((header) => {
        if (header != null && header.lsField != "" && header.lsField != null && header.lsField != "Descripcion")
          lsColumns.push(header.lsField);
      });

      const that = this;

      if (that.props.isDelay) {
        formatInstrumentForLS = formatInstrumentForLS.map((item) => "D." + item);
        formatInstrumentWithPositionFieldsForLS = formatInstrumentWithPositionFieldsForLS.map((item) => "D." + item);
      }

      const sub = getSubscription(
        "MERGE",
        [...formatInstrumentForLS, ...formatInstrumentWithPositionFieldsForLS],
        lsColumns
      );

      let data = {};
      let update = null;
      let tempRowNumber = 0;

      that.setState(({ activeCards }) => ({
        activeCards: [...activeCards, { ...activeCard, subscription: sub }],
      }));

      const { marketId } = activeCard;

      const isNationalBags =
        marketId === MarketTypes.BMV.id ||
        marketId === MarketTypes.BIVA.id ||
        marketId === MarketTypes.BMV_SIC.id ||
        marketId === MarketTypes.BIVA_SIC.id;

      const isIndexMarkets = marketId === MarketTypes.INDEX.id;

      that.setState({ subscription: sub });

      let columnList = activeCard.columnList;

      sub.addListener({
        onSubscription: function () {
          console.log("SUBSCRIBED");
        },
        onUnsubscription: function () {
          console.log("UNSUBSCRIBED");
        },
        onItemUpdate: function (obj: any) {
          data = null;
          update = null;
          const isPosture = obj.itemName && obj.itemName.includes("P.");
          if (!isPosture && isNationalBags) {
            const lsColumnIndex = formatInstrumentForLS.indexOf(String(obj.itemName));
            const rowsMoreInfo = activeCard && activeCard.rowMoreInfo ? activeCard.rowMoreInfo : [];
            if (rowsMoreInfo && rowsMoreInfo.length === formatInstrumentForLS.length) {
              data = that.getYields(obj, rowsMoreInfo[lsColumnIndex]);
            }
          }

          /* tslint:disable:no-unused-variable */
          obj.forEachChangedField((name, pos, val) => {
            if (isEmpty(val)) return pos;

            if (isEmpty(name)) return;

            let tempName = name;
            if (isNationalBags && isPosture) {
              if (name === "Hora") {
                tempName = LsSubscriptionTableFields.POSTURE_TIME;
              } else if (name === "Fecha") {
                tempName = LsSubscriptionTableFields.POSTURE_DATE;
              }
            }

            if (isIndexMarkets && tempName === LsSubscriptionTableFields.NYSE_STOCK_VALUE) {
              tempName = "Fecha";
            }

            update = columnList.find((tableElement) => tableElement.lsField === tempName);

            if (!update) return;

            let newVal = val;

            if (marketId === MarketTypes.INTERNATIONAL_BAGS.id && name === "VolumenTotal" && newVal && !isNaN(newVal)) {
              // $FlowFixMe
              newVal *= 1000;
            }
            data = { ...data, [update.lsField]: newVal };
          });
          if (data) {
            delete data[""];

            if (formatInstrumentForLS.includes(obj.itemName)) {
              tempRowNumber = formatInstrumentForLS.indexOf(obj.itemName);
            } else {
              tempRowNumber = formatInstrumentWithPositionFieldsForLS.indexOf(obj.itemName);
            }

            const { updateMarketTable } = that.state;
            if (!updateMarketTable) {
              that.updateRowTable({
                columnList,
                data: { ...data },
                startingColumnValue,
                finalColumnValue,
                rowNumber: rowNumber + tempRowNumber + 1,
                worksheetId,
              });
            }
          }
        },
      });
    } catch (error) {
      console.error(error);
    }
  };

  addTableToExcel = async ({
    formatInstrumentForLS,
    formatInstrumentWithPositionFieldsForLS,
    rows,
    tableName,
    address,
    marketId,
    worksheetId,
    columnList,
    instruments,
  }: AddTableParams) => {
    const that = this;
    let rowNumber = 0;
    let startingColumnValue = "";
    let finalColumnValue = "";
    let activeCard: Card = {
      address: "",
      finalColumn: "",
      finalRow: 0,
      initialColumn: "",
      initialRow: 0,
      rowNumber: 0,
      subscription: null,
      columnList: [],
      worksheetId: "",
      instruments: [],
      tableName: "",
      tableWithHeader: true,
    };

    try {
      await Excel.run(async (context) => {
        var activeCell = context.workbook.getSelectedRange();
        activeCell.load(["address", "values"]);
        await context.sync();
        var value = address ? address : activeCell.address;
        if (columnList.length > 0) {
          const { initialRow, finalRow, initialColumn, finalColumn } = calculateRange(String(value), columnList.length);
          startingColumnValue = initialColumn;
          finalColumnValue = finalColumn;

          activeCard = {
            ...activeCard,
            initialRow: Number(initialRow),
            finalRow: Number(finalRow),
            initialColumn: startingColumnValue,
            finalColumn,
            rowNumber: rows.length + 2,
            address: String(value),
            marketId,
            columnList: columnList,
            worksheetId: worksheetId,
            instruments: instruments,
            tableName,
            tableWithHeader: rememberCredentials,
          };
          var worksheet = context.workbook.worksheets.getActiveWorksheet();
          var rowHeader = Number(initialRow) + 1;

          if (rememberCredentials) {
            // table title

            let rangeTableName = worksheet.getRange(`${startingColumnValue}${initialRow}`);
            rangeTableName.values = [[tableName]];

            let rangeTableNameHeader = worksheet.getRange(
              `${startingColumnValue}${initialRow}:${finalColumn}${finalRow}`
            );
            rangeTableNameHeader.format.fill.color = BLACK;
            rangeTableNameHeader.format.font.color = WHITE;
            rangeTableNameHeader.format.font.size = 14;

            // table headers
            var tableHeader = worksheet.getRange(`${startingColumnValue}${rowHeader}:${finalColumn}${rowHeader}`);
            let currentCellHeader = startingColumnValue;
            let rangeHeader;
            columnList.forEach((header) => {
              rangeHeader = worksheet.getRange(`${currentCellHeader}${rowHeader}`);
              currentCellHeader = getNextColumn(currentCellHeader);

              if (Office.context.requirements.isSetSupported("ExcelApi", "1.2")) {
                rangeHeader.format.horizontalAlignment = header.align;
              }
              rangeHeader.format.font.size = 14;
              rangeHeader.values = String(header.name);
            });

            tableHeader.format.fill.color = BLACK;
            tableHeader.format.font.color = WHITE;
          } else {
            rowHeader = rowHeader - 2;
          }

          // table body
          let currentRow = Number(rowHeader);
          rowNumber = Number(rowHeader);
          let range;
          let currentCellBody;
          let valueCellBody;

          const isNationalBags =
            marketId === MarketTypes.BMV.id ||
            marketId === MarketTypes.BIVA.id ||
            marketId === MarketTypes.BMV_SIC.id ||
            marketId === MarketTypes.BIVA_SIC.id;

          const rowMoreInfo: RowMoreInfo[] = [];
          const isCurrency = marketId === MarketTypes.CURRENCY.id;
          let currencyPosturaPrecioCompraCell = null;
          let currencyPosturaPrecioVentaCell = null;
          // Read the row data

          rows.forEach((row) => {
            currentCellBody = startingColumnValue;
            currentRow++;

            if (isNationalBags) {
              const currentPrice = Number(row["precioActual"] || 0);
              const weeklyNumber = Number(row["rendimientoSemanal"] || 0) / 100;
              const monthlyNumber = Number(row["rendimientoMensual"] || 0) / 100;
              const annualNumber = Number(row["rendimientoAnual"] || 0) / 100;
              const annualYield = Number(row["rendimientoAlAnio"] || 0) / 100;

              const semanalPrice = currentPrice / (weeklyNumber + 1);
              const monthlyPrice = currentPrice / (monthlyNumber + 1);
              const annualPrice = currentPrice / (annualNumber + 1);
              const enAnoPrice = currentPrice / (annualYield + 1);

              rowMoreInfo.push({
                displaySymbol: row.descripcion || "",
                semanalPrice,
                monthlyPrice,
                annualPrice,
                enAnoPrice,
              });
            }
            columnList.forEach(async (header) => {
              range = worksheet.getRange(`${currentCellBody}${currentRow}`);
              if (header.apiField === "pppOficial") {
                valueCellBody = row.precioPP || "0.0000";
              } else {
                valueCellBody = row[header.apiField];
              }

              if (Office.context.requirements.isSetSupported("ExcelApi", "1.2")) {
                range.format.horizontalAlignment = header.align;
              }

              if (isCurrency) {
                if (!currencyPosturaPrecioCompraCell && header.apiField === "posturaPrecioCompra") {
                  currencyPosturaPrecioCompraCell = currentCellBody;
                }
                if (!currencyPosturaPrecioVentaCell && header.apiField === "posturaPrecioVenta") {
                  currencyPosturaPrecioVentaCell = currentCellBody;
                }
              }
              if (
                marketId === MarketTypes.REFERENCE_RATES.id &&
                (header.apiField === "valorActual" || header.apiField === "valorAnterior")
              ) {
                valueCellBody = convertValueToPercentage(valueCellBody ? String(valueCellBody) : "");
              }
              currentCellBody = getNextColumn(currentCellBody);
              if (isCurrency && header.name === "spread") {
                range.numberFormat = "###########0.00###########";
                range.values = `=${currencyPosturaPrecioVentaCell}${currentRow}-${currencyPosturaPrecioCompraCell}${currentRow}`;
              } else {
                if (header.format == formats.DATE) {
                  range.numberFormat = "dd-MM-yy";
                  range.values = convertValue(valueCellBody, header, false);
                } else {
                  range.values = convertValue(valueCellBody, header, false);
                }
              }
            });
          });

          activeCard = {
            ...activeCard,
            rowMoreInfo,
          };

          if (Office.context.requirements.isSetSupported("ExcelApi", "1.2")) {
            worksheet.getUsedRange().format.autofitColumns();
          }
          return context.sync().then(() => {
            this.props.setShowSpinner(false);
          });
        } else {
          this.props.setShowSpinner(false);
          <Alert
            open={initDataAlert.showAlert}
            type={initDataAlert.type}
            title={initDataAlert.title}
            message={initDataAlert.message}
            handleClose={this.handleCloseAlert}
            emitter={this.handleEmitterAlert}
            sizeOverride={70}
          />;
        }
        await context.sync();
      });

      that.getRealTime({
        formatInstrumentForLS,
        formatInstrumentWithPositionFieldsForLS,
        rowNumber,
        startingColumnValue,
        finalColumnValue,
        activeCard,
        worksheetId,
      });
    } catch (error) {
      console.error("err RealTime: ", error);
      this.props.setShowSpinner(false);
    }
    finalColumnArr = [];
    rememberCredentials = true;
  };

  addHistoicalDataToTable = async (chipArray, startDate, endDate, columnData) => {
    let data;
    this.props.setShowSpinner(true);
    try {
      for (let i = 0; i < chipArray.length; i++) {
        if (chipArray[i].marketId == 9 || chipArray[i].marketId == 8 || chipArray[i].marketId == 27) {
          data = await getHistoricalData(chipArray[i].instrumentKey, startDate, endDate);
          chipArray[i].historicData = await data.data;
        }

        if (chipArray[i].marketId == 23) {
          data = await getHistoricalFundData(chipArray[i].instrumentKey, startDate, endDate);
          chipArray[i].historicData = await data.data;
        }

        if (chipArray[i].marketId == 21) {
          data = await getHistoricalIndicatorsData(chipArray[i].instrumentKey, startDate, endDate);
          chipArray[i].historicData = await data.data;
        }

        if (chipArray[i].marketId == 24) {
          data = await getHistoricalReferralTessaData(chipArray[i].instrumentKey, startDate, endDate);
          chipArray[i].historicData = await data.data;
        }

        if (chipArray[i].marketId == 26) {
          data = await getHistoricalReferralMateriasData(chipArray[i].instrumentKey, startDate, endDate);
          chipArray[i].historicData = await data.data;
        }
      }
      let instrumentsLength = chipArray.length;

      let includedColumData = columnData.map((item) => item.Name);

      const columList = historyColumList.filter((item) => includedColumData.includes(item.label));

      await Excel.run(async (context) => {
        let initalStartCol = "";
        let initalStartRow = "";

        for (let i = 0; i < instrumentsLength; i++) {
          var activeCell;
          if (initalStartCol.length > 0) {
            activeCell = context.workbook.worksheets
              .getActiveWorksheet()
              .getRange(`${initalStartCol}${initalStartRow}`);
          } else {
            activeCell = context.workbook.getSelectedRange();
          }

          activeCell.load(["address", "values", "worksheet/id"]);

          await context.sync();

          var worksheetId = activeCell.worksheet.id;
          var address = activeCell.address;
          var value = address ? address : activeCell.address;

          const { initialRow, finalRow, initialColumn, finalColumn } = calculateRange(String(value), columList.length);
          var startingColumnValue = initialColumn;
          var finalColumnValue = finalColumn;
          var initialRowValue = initialRow;
          var finalRowValue = finalRow;

          var worksheet = context.workbook.worksheets.getActiveWorksheet();
          var rowHeader = Number(initialRow) + 1;
          let rangeTableName = worksheet.getRange(`${startingColumnValue}${initialRow}`);
          rangeTableName.values = [[chipArray[i].displaySymbol]];

          let rangeTableNameHeader = worksheet.getRange(
            `${startingColumnValue}${initialRow}:${finalColumn}${finalRow}`
          );
          rangeTableNameHeader.format.fill.color = BLACK;
          rangeTableNameHeader.format.font.color = WHITE;
          rangeTableNameHeader.format.font.size = 14;

          var tableHeader = worksheet.getRange(`${startingColumnValue}${rowHeader}:${finalColumn}${rowHeader}`);
          let currentCellHeader = startingColumnValue;
          let rangeHeader;

          tableHeader.format.fill.color = BLACK;
          tableHeader.format.font.color = WHITE;

          columList.forEach((header) => {
            rangeHeader = worksheet.getRange(`${currentCellHeader}${rowHeader}`);
            currentCellHeader = getNextColumn(currentCellHeader);

            if (Office.context.requirements.isSetSupported("ExcelApi", "1.2")) {
              rangeHeader.format.horizontalAlignment = header.align;
            }
            rangeHeader.format.font.size = 14;
            rangeHeader.values = String(header.name);
          });

          var currentRow = Number(rowHeader);
          let rowNumber = Number(rowHeader);
          let range;
          let currentCellBody;
          let valueCellBody;

          initalStartCol = getNextColumn(finalColumnValue);
          initalStartCol = getNextColumn(initalStartCol);
          initalStartRow = finalRowValue;

          // Read the row data
          chipArray[i].historicData?.forEach((row) => {
            currentCellBody = startingColumnValue;
            currentRow++;

            columList.forEach((header) => {
              range = worksheet.getRange(`${currentCellBody}${currentRow}`);

              switch (header.name) {
                case "Fecha":
                  range.numberFormat = "dd-MM-yy";
                  let date = row["datetime"] || row["fecha"] || row["date"];
                  range.values = date.slice(0, 10);
                  break;
                case "Apertura":
                  range.numberFormat = "##,##,##,##,##,##0.00###########";
                  range.values = row["open"];
                  break;
                case "Cierre":
                  range.numberFormat = "##,##,##,##,##,##0.00###########";
                  range.values = row["close"];
                  break;
                case "Máximo":
                  range.numberFormat = "##,##,##,##,##,##0.00###########";
                  range.values = row["high"];
                  break;
                case "Mínimo":
                  range.numberFormat = "##,##,##,##,##,##0.00###########";
                  range.values = row["low"];
                  break;
                case "Volumen":
                  range.numberFormat = "##,##,##,##,##,##0";
                  range.values = row["volume"];
                  break;
                case "Precio":
                  range.numberFormat = "##,##,##,##,##,##0.00###########";
                  let price = row["amount"] || row["price"];
                  range.values = price;
                  break;
                case "Valor":
                  range.numberFormat = "##,##,##,##,##,##0.00###########";
                  range.values = row["valor"];
                  break;
                case "Rendimiento mensual":
                  range.numberFormat = "##,##,##,##,##,##0.00###########";
                  range.values = row["oneMonth"];
                  break;
                case "Rendimiento anualizado mensual":
                  range.numberFormat = "##,##,##,##,##,##0.00###########";
                  range.values = row["oneMonthCompounded"];
                  break;
                case "Rendimiento semanal":
                  range.numberFormat = "##,##,##,##,##,##0.00###########";
                  range.values = row["oneWeek"];
                  break;
                case "Rendimiento anualizado semanal":
                  range.numberFormat = "##,##,##,##,##,##0.00###########";
                  range.values = row["oneWeekCompounded"];
                  break;
                case "Rendimiento anual":
                  range.numberFormat = "##,##,##,##,##,##0.00###########";
                  range.values = row["twelveMonths"];
                  break;
                case "Rendimiento en el año":
                  range.numberFormat = "##,##,##,##,##,##0.00###########";
                  range.values = row["yearToDate"];
                  break;
                case "Rendimiento anualizado en el año":
                  range.numberFormat = "##,##,##,##,##,##0.00###########";
                  range.values = row["yearToDateCompounded"];
                  break;
                case "Nivel":
                  range.numberFormat = "##,##,##,##,##,##0.00###########";
                  const nivel = row["nivel"] || row["value"];
                  range.values = nivel;
              }

              range.format.autofitColumns();
              currentCellBody = getNextColumn(currentCellBody);
            });
          });
        }
        await context.sync();
        this.setState({
          downloadHistorySuccess: true,
        });
      });
    } catch (err) {
      console.log(err, "err");
      this.props.setShowSpinner(false);
      this.setState({
        downloadHistorySuccess: false,
      });
    }
    this.props.setShowSpinner(false);
  };

  getDownloadHistoryStatus = () => {
    return this.state.downloadHistorySuccess;
  };

  render() {
    const { dataSnackbar, dataAlert } = this.state;
    const { classes } = this.props;

    return (
      <div className={classes.root}>
        <Header title="titulo" logo="assets/logo.png" logOutUser={this.props.logOutUser} />
        {this.state.errorRender ? (
          <NewTable StateRespone={this.state.responsestate} handleclose={this.handlecloseerror} />
        ) : (
          <Container>
            <div className={classes.customTab}>
              <Button
                className={`${
                  this.state.activeTab === "Insertar tabla" ? classes.activeCustomButton : classes.customButton
                }`}
                onClick={() => this.setState({ activeTab: "Insertar tabla" })}
              >
                Insertar tabla
              </Button>
              {/* <Button className={`${this.state.activeTab === "Descarga masiva" ? classes.activeCustomButton : classes.customButton}`} onClick={() => this.setState({ activeTab: "Descarga masiva" })}>Descarga masiva</Button> */}
            </div>
            {this.state.activeTab === "Insertar tabla" ? (
              <Market
                setShowSpinner={this.props.setShowSpinner}
                onClickMarket={this.onClickMarket}
                handleCallback={this.handleCallback}
                onCutAddTable={this.cutAddTable}
                onCopyAddTable={this.copyAddTable}
                onPasteAddTable={this.pasteAddTable}
                cardPaste={this.state.cardPaste}
                cardTableEnabled={this.state.cardTableEnabled}
              />
            ) : (
              <SideTab
                setShowSpinner={this.props.setShowSpinner}
                onClickMarket={this.onClickMarket}
                setColumArr={this.setColumArr}
                rememberCredentials={this.handleRememberCredentials}
                addHistoicalDataToTable={this.addHistoicalDataToTable}
                getDownloadHistoryStatus={this.getDownloadHistoryStatus}
              />
            )}
            <>
              {dataSnackbar.showSnackbar ? (
                <SnackbarContent
                  open={dataSnackbar.showSnackbar}
                  handleClose={this.handleCloseSnackbar}
                  severity={dataSnackbar.severity}
                  message={dataSnackbar.message}
                  autoHideDuration={dataSnackbar.autoHideDuration}
                />
              ) : null}
              {dataAlert.showAlert ? (
                <Alert
                  open={dataAlert.showAlert}
                  type={dataAlert.type}
                  title={dataAlert.title}
                  message={dataAlert.message}
                  handleClose={this.handleCloseAlert}
                  emitter={this.handleEmitterAlert}
                  sizeOverride={70}
                />
              ) : null}
            </>
          </Container>
        )}
      </div>
    );
  }
}

export default withStyles(styles)(ExcelAddIn);

const handleSelectionChange = (event) => {
  return Excel.run(function (context) {
    return context.sync().then(function () {
      const { activeCards, cardTableEnabled, cardPaste, copyBtn } = self.state;
      const address = event.address.split(":")[0];

      const card = getCardByAddress(activeCards, "Sheet!" + address, event.worksheetId);

      if (card) {
        self.setState({ cardTableEnabled: true });
      } else {
        self.setState({ cardTableEnabled: false });
      }
    });
  });
};

const handleRowSorted = (event) => {
  return Excel.run(async function (context) {
    await context.sync().then(async function () {
      const { activeCards } = self.state;
      const { getRealTime } = self;
      const address = event.address.split(":")[0];
      const activeCard = getCardByAddress(activeCards, "Sheet!" + address, event.worksheetId);
      let activedCards = activeCards.filter((x) => x.address == activeCard.address);
      var worksheet = context.workbook.worksheets.getItem(event.worksheetId);
      const endRow = activeCard.initialRow + activeCard.instruments.length + 1;
      if (client && activedCards && activedCards.length > 0) {
        activedCards.forEach(async (activeCard) => {
          await client.unsubscribe(activeCard.subscription);
          activeCard.subscription.removeListener(activeCard.address);
        });
      }
      const sheetAddress = `${activeCard.initialColumn}${activeCard.initialRow + 2}:${
        activeCard.initialColumn
      }${endRow}`;
      let range = worksheet.getRange(sheetAddress);
      let startingColumnValue = activeCard.initialColumn;
      let rowNumber = activeCard.initialRow + 1;
      let finalColumnValue = activeCard.finalColumn;
      let worksheetId = event.worksheetId;
      range.load(["values"]);
      await context.sync();

      formatInstrumentForLS = range["m_values"].map(
        (item) =>
          `${activeCard.instruments[0].marketTypeId}.${activeCard.instruments[0].valueTypeId}.${activeCard.instruments[0].exchangeId}.${item[0]}`
      );

      formatInstrumentWithPositionFieldsForLS = range["m_values"].map(
        (item) =>
          `P.${activeCard.instruments[0].marketTypeId}.${activeCard.instruments[0].valueTypeId}.${activeCard.instruments[0].exchangeId}.${item[0]}`
      );

      getRealTime({
        formatInstrumentForLS,
        formatInstrumentWithPositionFieldsForLS,
        rowNumber,
        startingColumnValue,
        finalColumnValue,
        activeCard,
        worksheetId,
      });
    });
  });
};
